import { ReactRenderer } from "@tiptap/react";
import { MentionList } from "./MentionList.jsx";

// `getUsers()` se lee en cada búsqueda (no en el momento de crear la extensión) para no
// quedar con una lista de usuarios obsoleta -- el editor se crea una sola vez (ver
// TaskCommentEditor.jsx), pero `systemUsers`/`spaceMembersData` del componente padre puede
// cambiar mientras el editor sigue montado.
export function createTaskCommentSuggestion({ getUsers, onActiveChange, onMentionSelect }) {
    return {
        char: "@",
        // Por default @tiptap/suggestion solo dispara el popup si el "@" está precedido de un
        // espacio o es el primer caracter del bloque (`allowedPrefixes: [" "]`) -- si el usuario
        // lo escribe pegado a otra palabra (sin espacio antes), el "@" se inserta como texto
        // plano y la mención nunca se abre. `null` desactiva esa restricción: cualquier "@" es
        // un trigger válido, sin importar qué lo precede.
        allowedPrefixes: null,
        items: ({ query }) => {
            const users = getUsers() || [];
            const lower = query.toLowerCase();
            return users
                .filter((u) => (u.nick || u.name || "").toLowerCase().includes(lower))
                .slice(0, 8)
                .map((u) => ({
                    id: u.id ?? u.dbId,
                    nick: u.nick || u.name,
                    avatar: (u["link-profile-img-thumb"] || u["link-profile-img"]) || u.image || `https://ui-avatars.com/api/?name=${encodeURIComponent(u.nick || u.name || "User")}`,
                }));
        },
        command: ({ editor, range, props }) => {
            editor
                .chain()
                .focus()
                .insertContentAt(range, [
                    { type: "mention", attrs: { uid: String(props.id), name: props.nick, avatar: props.avatar } },
                    { type: "text", text: " " },
                ])
                .run();
            // Integración main→dev, epic D1.4 — en tareas estructuradas, mencionar a alguien sin
            // acceso al documento vinculado abre el modal para compartírselo.
            if (typeof onMentionSelect === "function") {
                try {
                    onMentionSelect(props);
                } catch (err) {
                    console.error("[taskCommentSuggestion] Error in onMentionSelect:", err);
                }
            }
            },
        render: () => {
            let component;
            let unmount;

            return {
                onStart: (props) => {
                    onActiveChange?.(true);
                    component = new ReactRenderer(MentionList, { props, editor: props.editor });
                    if (!props.clientRect) return;
                    if (component.element) {
                        component.element.style.zIndex = "99999999";
                        component.element.style.pointerEvents = "auto";
                    }
                    unmount = props.mount(component.element);
                },
                onUpdate: (props) => {
                    component.updateProps(props);
                    if (component.element) {
                        component.element.style.zIndex = "99999999";
                        component.element.style.pointerEvents = "auto";
                    }
                },
                onKeyDown: (props) => {
                    if (props.event.key === "Escape") {
                        onActiveChange?.(false);
                        unmount?.();
                        return true;
                    }
                    return component.ref?.onKeyDown(props) ?? false;
                },
                onExit: () => {
                    onActiveChange?.(false);
                    unmount?.();
                    component.destroy();
                },
            };
        },
    };
}
